export default __webpack_public_path__ + "media/landscape/logo_squarespace-664ac011.svg";